import { Transforms } from 'slate'
import { useEditor } from 'slate-react'
import React from 'react'

import { useColor } from '../../../kiti/components/theme/_hooks/colors'
import BlockPlugin from './BlockPlugin'
import EditorIcon from '../EditorIcon'

const Element = ({ children, attributes, element, ...props }) => {
  const color = useColor('light2')

  return (
    <div {...attributes} contentEditable={false}>
      <hr style={{ border: 'none', borderBottom: `2px solid ${color}`, borderRadius: '5px' }} />
      {children}
    </div>
  )
}

const insertSeparatorOnContent = editor => {
  const text = { text: '' }
  const node = { type: 'separator', children: [text] }
  Transforms.insertNodes(editor, node)
  Transforms.move(editor)
}

const PluginIcon = props => {
  const editor = useEditor()
  return <EditorIcon icon="RiSeparator" onClick={() => insertSeparatorOnContent(editor)} {...props} />
}

const extend = editor => {
  const { isVoid, markableVoid } = editor

  editor.isVoid = element => {
    return element.type === 'separator' ? true : isVoid(element)
  }

  editor.markableVoid = element => {
    return element.type === 'separator' || markableVoid(element)
  }

  return editor
}

const SeparatorPlugin = {
  ...BlockPlugin,
  Icon: PluginIcon,
  Element,
  extend
}

export default SeparatorPlugin
